// All editable site text lives here. Edit values to update the website content.
export const translations = {
  de: {
    nav: {
      home: "Home",
      news: "News",
      trainer: "Trainer",
      kurse: "Kurse",
      einzeltraining: "Einzeltraining",
      onlinecoaching: "Onlinecoaching",
      golfclub: "Golfclub",
      kontakt: "Kontakt",
      impressum: "Impressum",
      cta: "Jetzt starten",
    },
    marquee: "POWERED BY GOLFCOACHING.ONLINE  ///  GANZHEITLICHES GOLFTRAINING  ///  VOM ANFÄNGER BIS PROFI  ///  GC KIRCHHEIM-WENDLINGEN  ///",
    home: {
      kicker: "// GOLFCOACHING ACADEMY // WENDLINGEN",
      h1a: "GOLF",
      h1b: "GANZHEITLICH.",
      sub: "Die neue Golfschule von PGA-Coach Michael Wolf im Golfclub Kirchheim-Wendlingen e.V. Ganzheitliches Training – vom ersten Schwung bis zum Profi-Niveau.",
      newsletterLabel: "Newsletter abonnieren",
      namePh: "Dein Name",
      emailPh: "Deine E-Mail-Adresse",
      subscribe: "Anmelden",
      subscribed: "Danke! Du bist auf der Liste.",
      learnCourses: "Kurse entdecken",
      stat1: "30+", stat1l: "Jahre Coaching",
      stat2: "PGA", stat2l: "Professional",
      stat3: "360°", stat3l: "Ganzheitlich",
      newsKicker: "// NEWS // UPDATES",
      newsTitle: "Aktuelles",
      offersKicker: "// PROGRAMME",
      offersTitle: "Dein Weg. Dein Golf.",
      offers: [
        { t: "Kurse", d: "Strukturierte Gruppenkurse für Einsteiger & Fortgeschrittene inkl. Platzreife.", to: "/kurse" },
        { t: "Einzeltraining", d: "Individuelles 1:1-Coaching mit Technik- und Videoanalyse.", to: "/einzeltraining" },
        { t: "Onlinecoaching", d: "Trainiere von überall – Videoanalyse & persönlicher Trainingsplan.", to: "/onlinecoaching" },
      ],
      more: "Mehr erfahren",
    },
    trainer: {
      kicker: "// DEIN TRAINER",
      title: "Michael Wolf",
      role: "Founder & Head Coach · PGA Golfprofessional · Ex-Tour Player",
      bio: [
        "Michael Wolf ist PGA Golfprofessional, ehemaliger Tour-Spieler und Deutscher DGL Meister. Mit über 30 Jahren Erfahrung im Golfsport coacht er Spieler aller Levels – vom absoluten Anfänger bis zum ambitionierten Wettkampfspieler. Zudem hat er Sportökonomie studiert.",
        "Sein Ansatz ist ganzheitlich: Technik, Athletik, Mentaltraining und Strategie greifen ineinander. Als Gründer von golfcoaching.online verbindet er moderne Online-Methoden mit persönlichem Training vor Ort.",
        "In der Golfcoaching Academy Wendlingen im Golfclub Kirchheim-Wendlingen e.V. bringt er dieses Wissen direkt auf die Range – ebenso ist er im GC Neckartal e.V. als Trainer tätig.",
      ],
      qualsTitle: "Qualifikationen",
      quals: [
        "PGA Golfprofessional",
        "Ehemaliger Tour-Spieler",
        "Deutscher Meister",
        "Gründer golfcoaching.online",
        "Studium der Sportökonomie",
        "Ehemaliger Coach 1. Bundesliga",
      ],
      cta: "Training anfragen",
    },
    trainer2: {
      kicker: "// TRAINER 02",
      title: "Christian Tobias",
      role: "PGA Golfprofessional · Golflehrer PGA of Germany · seit 1989",
      bio: [
        "Christian Tobias ist Golflehrer der PGA of Germany und seit 1989 mit Leidenschaft auf der Range zuhause. Als studierter Sportwissenschaftler verbindet er Technik, Taktik und Athletik zu einem stimmigen Spiel.",
        "Sein Credo: „Inspired by Difference.\" Kein Mensch und kein Schwung sind gleich – ein starres Schema „F\" hat im Unterricht nichts verloren. Durch präzise Beobachtung Deiner Bewegungsabläufe passt er den Schwung exakt an Deine körperlichen Möglichkeiten an.",
        "Über drei Jahrzehnte sammelte er Erfahrung als (Head-)Pro an renommierten Clubs in Deutschland und Florida – von Schloß Monrepos über Sigmaringen bis Fort Myers. Heute bringt er dieses Wissen in die Golfcoaching Academy Wendlingen.",
      ],
      qualsTitle: "Qualifikationen",
      quals: [
        "Golflehrer PGA of Germany (seit 1989)",
        "Studium der Sportwissenschaften",
        "Headpro u.a. Schloß Monrepos & Sigmaringen",
        "Stationen in Deutschland & Florida (USA)",
        "Personal Trainer & Taktik-Coach",
      ],
      cta: "Training anfragen",
    },
    trainer3: {
      kicker: "// TRAINER 03",
      title: "Moritz Ehrismann",
      role: "PGA Professional · Jugend- & Einsteiger-Coach",
      bio: [
        "Seit neun Jahren lebt Moritz Ehrismann für den Golfsport. In seinem Heimatclub Bad Liebenzell spielte er sein Handicap schon zwei Jahre nach dem Einstieg auf 9 – als Jugendlicher sogar bis auf ein Best-Handicap von 5. Heute bewegt er sich konstant zwischen Handicap 0 und 3.",
        "Zahlreiche Turniersiege, unter anderem im GC Bad Liebenzell, prägten sein tiefes Verständnis für das Spiel. Diese Erfahrung als aktiver Wettkampfspieler gibt er heute direkt an seine Schüler weiter.",
        "Nach seiner C-Trainer-Ausbildung sammelte er wertvolle Erfahrung am Öschberghof und absolvierte anschließend die Ausbildung zum PGA Professional am Hetzenhof. Heute ist er selbstständiger PGA Professional – mit voller Leidenschaft und einem besonderen Talent, Golf einfach zu erklären.",
      ],
      qualsTitle: "Qualifikationen",
      quals: [
        "PGA Professional",
        "Spielstärke Handicap 0–3",
        "Stärke: Kinder & Jugendliche",
        "Golf einfach & verständlich erklärt",
        "Mehrfacher Turniersieger (Bad Liebenzell)",
        "Ausbildung: Öschberghof & Hetzenhof",
      ],
      cta: "Training anfragen",
    },
    trainer4: {
      kicker: "// TRAINER 04",
      title: "Mikael Krantz",
      monogram: "MK",
      role: "PGA Golf Professional · Ex-European-Tour-Spieler · Graduierung G4",
      bio: [
        "Mikael Krantz spielt Golf seit 1973 und war als Playing Professional viele Jahre international erfolgreich. Auf der European Tour (1989–1994) und der Challenge Tour (1991–1999) maß er sich mit Größen wie Bernhard Langer, Seve Ballesteros und Tiger Woods – fünf Challenge-Tour-Siege und drei Starts bei den British Open gehören zu seinen Highlights.",
        "2004 zog der gebürtige Schwede nach Deutschland und unterrichtet seither auf der Golfanlage Kirchheim-Wendlingen. Seine internationale Tour-Erfahrung verbindet er mit fundiertem, modernem Coaching.",
        "Ob Einsteiger, ambitionierter Turnierspieler oder Seniorengolfer – Mikael trainiert individuell, praxisnah und auf jedem Spielniveau. Ein erfahrener Partner, der genau weiß, worauf es auf dem Platz ankommt.",
      ],
      qualsTitle: "Erfahrung",
      quals: [
        "PGA Golflehrer seit 2003 (G4)",
        "Golf seit 1973 · Playing Pro seit 1988",
        "European Tour 1989–1994",
        "5 Tour-Siege (Challenge Tour)",
        "3× British-Open-Teilnahme",
        "Einsteiger, Turnier- & Seniorengolf",
      ],
      cta: "Training buchen",
    },
    kurse: {
      kicker: "// KURSE & EVENTS · ONLINE BUCHEN",
      title: "Kurse",
      intro: "Wähle Deinen Kurs, sieh freie Termine im Kalender und buche in wenigen Klicks online.",
      emptyText: "Aktuell sind keine Kurse buchbar. Schau bald wieder vorbei.",
      calendarKicker: "// JAHRESKALENDER",
      calendarTitle: "Termine",
      regelkursKicker: "// PLATZREIFE · THEORIE",
      regelkursTitle: "Regelkurs & Regel-Tests",
      regelkursText1: "Mit diesem Online-Regelkurs möchten wir Ihnen die Golfregeln auf genauso informative wie praxisnahe Weise vermitteln.",
      regelkursText2: "Machen Sie sich stark: Denn nur mit fundierter Regelkunde spielen Sie in Turnieren sicher und können entscheiden, wann und wie Sie straffrei Erleichterung erhalten.",
      regelkursCta: "Zum Regelkurs",
      voucherTitle: "Golfkurs-Gutschein verschenken",
      voucherText: "Wertgutschein für Kurse & TrackMan · 3 Jahre gültig · sofort als PDF",
      voucherCta: "Jetzt verschenken",
    },
    regelkurs: {
      kicker: "// REGELKURS · PLATZREIFE",
      title: "Regelkurs",
      intro: "Absolviere hier Deine Regel-Tests und bestehe den Regelteil der Platzreife – online, in Deinem Tempo. Arbeite die Lektionen durch und schließe am Ende den Regeltest ab.",
      note: "Bereitgestellt über Golftimer · Fortschritt wird im Regelsystem gespeichert",
    },
    gutschein: {
      kicker: "Verschenken",
      title: "Golf-Gutschein",
      intro: "Verschenke Golferlebnisse: Der Wertgutschein ist für Gruppenkurse und TrackMan einlösbar, 3 Jahre gültig und wird als PDF zum Ausdrucken versendet.",
      redeemNote: "Einlösbar für Gruppenkurse und TrackMan-Buchungen. Nicht für Einzeltraining/1:1. Teil-Einlösung möglich – Restguthaben bleibt erhalten.",
    },
    einzel: {
      kicker: "// 1:1 // EINZELTRAINING",
      title: "Einzeltraining",
      intro: "Maximaler Fortschritt durch individuelles Coaching. Jede Einheit ist exakt auf Dich, Dein Level und Deine Ziele zugeschnitten.",
      features: [
        { t: "Videoanalyse", d: "Detaillierte Schwung- und Bewegungsanalyse in Zeitlupe." },
        { t: "Individueller Plan", d: "Ein Trainingsplan, der genau zu Deinen Zielen passt." },
        { t: "Ganzheitlich", d: "Technik, Athletik, Mental und Strategie in einem Konzept." },
        { t: "Flexible Termine", d: "Trainingszeiten, die sich Deinem Alltag anpassen." },
      ],
      cta: "Termin anfragen",
    },
    online: {
      kicker: "// POWERED BY GOLFCOACHING.ONLINE",
      badge: "www.golfcoaching.online",
      h1a: "DEINE GOLF",
      h1b: "ONLINE PLATTFORM",
      intro: "golfcoaching.online ist eine Streaming-Plattform, aber auch vieles mehr. Hunderte Masterclass-Videos von weltbekannten Coaches. Integrierter KI Swing Coach, Online-Shop, Blog, Chatroom, Rabatte und vieles mehr. Die perfekte Ergänzung zu Deinem Training auf dem Platz.",
      netflix: "Dein Golf-Netflix – besser als YouTube.",
      launch: "Official Launch · 1. Februar",
      ctaText: "Jetzt zur Plattform",
      ctaUrl: "www.golfcoaching.online",
      watch: "Jetzt streamen",
      oneStop: 'Der „One Stop Shop" für Online-Golflearning.',
      aiKicker: "// KI SWING COACH",
      aiTitle: "Dein persönlicher KI Swing Coach",
      aiText: "Lade Dein Schwung-Video hoch und erhalte in Sekunden eine professionelle Analyse – Technik, Fehlerquellen und konkrete Übungen. Verfügbar rund um die Uhr, direkt auf Deinem Smartphone.",
      aiBullets: ["Schwung-Video hochladen", "Sofortige KI-Analyse", "Konkretes Feedback & Drills", "Fortschritt verfolgen"],
      featKicker: "// DIE PLATTFORM",
      featTitle: "Alles in einem Abo",
      features: [
        { t: "Video-Streaming", d: "Netflix-ähnliche Masterclass-Bibliothek für jedes Level und jedes Thema." },
        { t: "KI Swing Coach", d: "Schwung hochladen, sofort professionelle Analyse & Feedback erhalten." },
        { t: "Online-Shop", d: "Exklusive Produkte, Equipment und Member-Rabatte." },
        { t: "Und vieles mehr", d: "E-Books, Trainingspläne, Community und laufend neue Inhalte." },
      ],
      teamKicker: "// DIE COACHES",
      teamTitle: "Lerne von den Besten",
      teamIntro: "Tour-Profis, PGA Professionals und Experten aus aller Welt – exklusiv auf golfcoaching.online.",
      showcaseTitle: "Streame auf allen Geräten",
      mcKicker: "// MASTERCLASSES",
      mcTitle: "Ganzheitliche Masterclasses",
      mcIntro: "Von Tour-Strategie bis Putting – auf golfcoaching.online findest Du strukturierte Masterclasses zu jedem Thema Deines Golfspiels. Erstellt von Michael Wolf und weltbekannten Experten.",
      topics: ["Tour", "Taktik", "Technik", "Anfängertipps", "Ernährung", "Statistik", "Short Game", "Putting", "Long Game", "Mental", "Fitness", "Yoga", "Breathwork", "Golf IQ", "Flaws & Fixes", "On-Course Coaching"],
      plansKicker: "// MITGLIEDSCHAFT",
      plansTitle: "Membership Plans",
      plansIncludeTitle: "Alle Mitgliedschaften beinhalten:",
      includes: [
        "Zugang zu allen Videos",
        "Zugang zum KI Golf Coach",
        "Member Benefits & Rabatte (bald)",
        "Community Blog (bald)",
        "Mitglieder-Chatroom (bald)",
      ],
      trial: "Kostenlos testen",
      popular: "Beliebt",
      plans: [
        { name: "6 Monate Bronze", price: "49", per: "Pro Monat", valid: "Gültig für 6 Monate · + 14 Tage gratis", features: ["Zugang zu allen Videos", "KI Golf Coach", "Member Benefits & Rabatte", "Community Blog", "Mitglieder-Chatroom"] },
        { name: "12 Monate Silber", price: "29", per: "Pro Monat", valid: "Gültig für 12 Monate · + 3 Tage gratis", features: ["Zugang zu allen Videos", "KI Golf Coach", "Member Benefits & Rabatte", "Community Blog", "Mitglieder-Chatroom"] },
        { name: "24 Monate Gold", price: "24", per: "Pro Monat", valid: "Gültig für 24 Monate · + 3 Tage gratis", popular: true, features: ["Zugang zu allen Videos", "KI Golf Coach", "Member Benefits & Rabatte", "Community Blog", "Mitglieder-Chatroom"] },
        { name: "5 Jahre Platinum VIP", price: "1.200", per: "Alle 5 Jahre", valid: "3 Tage gratis testen", features: ["15% Rabatt auf Gold-Plan", "Früher Zugang zu Live-Events & Retreats", "VIP Platinum Geschenk", "Zugang zu allem"] },
      ],
    },
    kontakt: {
      kicker: "// KONTAKT",
      title: "Kontakt",
      intro: "Bereit loszulegen? Schreib uns – wir melden uns schnellstmöglich zurück.",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      subject: "Betreff",
      message: "Nachricht",
      send: "Nachricht senden",
      sent: "Danke! Deine Nachricht wurde gesendet.",
      addressTitle: "Standort",
      address: "Golfcoaching Academy Wendlingen\nGolfclub Kirchheim-Wendlingen e.V.\nDeutschland",
      emailLabel: "E-Mail",
      emailValue: "training@wolfmichael.de",
    },
    impressum: {
      kicker: "// RECHTLICHES",
      title: "Impressum",
      content: `Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)

Golfcoaching Academy Wendlingen
Inhaber
Michael Wolf – Golfprofessional
Ringstraße 8
70736 Fellbach
Deutschland

Kontakt
Telefon: +49 (0)151 41929686
E-Mail: training@wolfmichael.de
Webseite: www.golfcoaching-academy.online

Umsatzsteuer-Identifikationsnummer
Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
DE815679035

Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV
Michael Wolf
Ringstraße 8
70736 Fellbach
Deutschland

Berufsbezeichnung
Golfprofessional
Berufsbezeichnung verliehen in Deutschland.

Trainingsstandort
Die Golfcoaching Academy Wendlingen bietet Golfunterricht, Kurse, Platzreifekurse und Veranstaltungen auf der Golfanlage des Golfclub Kirchheim-Wendlingen e.V. an.
Der Golfclub Kirchheim-Wendlingen e.V. ist nicht Betreiber dieser Webseite und übernimmt keine Verantwortung für deren Inhalte.
Vertragspartner sämtlicher auf dieser Webseite angebotenen Leistungen ist ausschließlich:
Michael Wolf – Golfprofessional

Haftung für Inhalte
Die Inhalte dieser Webseite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Als Diensteanbieter sind wir gemäß den gesetzlichen Vorschriften für eigene Inhalte auf diesen Seiten verantwortlich.

Haftung für Links
Diese Webseite enthält Links zu externen Webseiten Dritter. Auf deren Inhalte haben wir keinen Einfluss. Für die Inhalte der verlinkten Seiten ist ausschließlich der jeweilige Betreiber verantwortlich.

Urheberrecht
Alle auf dieser Webseite veröffentlichten Inhalte, Bilder, Videos, Grafiken, Logos, Designs und Texte unterliegen dem deutschen Urheberrecht. Jede Vervielfältigung, Bearbeitung oder Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers.

Stand: Juli 2026`,
    },
    golfclub: {
      kicker: "// DER CLUB",
      title: "Golfclub",
      intro: "Die Golfcoaching Academy Wendlingen ist im Golfclub Kirchheim-Wendlingen e.V. zuhause – einer der schönsten Golfanlagen der Region Stuttgart. Hier trainierst Du auf gepflegten Fairways, einer modernen Driving Range und in einem einladenden Clubhaus.",
      rangeTitle: "Unsere TrackMan Range",
      rangeIntro: "Smarter trainieren, besser spielen. Auf 300 Metern Länge bietet unsere TrackMan Range den perfekten Raum für lange Drives und präzises Training – jeder Schlag wird sichtbar, messbar und leicht verständlich.",
      rangePoints: [
        "10 überdachte, beheizte Bays mit Bildschirmen – täglich bis 22 Uhr, wetterunabhängig",
        "Kostenlose TrackMan App (iOS & Android) – auch vom Rasenabschlag spielbar",
        "Präzise Daten zu Distanz, Ballflug & mehr – Fortschritte speichern und analysieren",
        "Virtuelle Runden auf internationalen Top-Plätzen plus Spiele & Challenges",
        "Perfekt für eigenständiges Training oder gemeinsam mit dem Pro",
        "Für jedes Spielniveau – vom Einsteiger bis zum ambitionierten Golfer",
      ],
      features: [
        { t: "Driving Range", d: "Moderne Range & Übungsgrüns für effektives, gezieltes Training.", long: "300 m lange, beidseitig bespielbare Driving Range mit 10 überdachten, beheizten Bays und moderner TrackMan- & SCOPE-Technologie. Dazu zwei große Putting-Grüns sowie Chip- & Pitch-Anlagen mit Übungsbunker – ideal für gezieltes, effektives Training auf jedem Level." },
        { t: "Mitten in der Natur", d: "Gepflegte Fairways in reizvoller Lage zwischen Kirchheim & Wendlingen.", long: "Eingebettet zwischen Kirchheim und Wendlingen liegt die Anlage in reizvoller Landschaft am Fuße der Schwäbischen Alb. Gepflegte Fairways, alter Baumbestand und weite Ausblicke machen jede Runde zu einem echten Naturerlebnis." },
        { t: "Clubhaus & Gastronomie", d: "Einladendes Clubhaus mit Gastronomie für den Ausklang nach der Runde.", long: "Das einladende Clubhaus bietet ein Restaurant mit sonniger Terrasse und einen Pro-Shop. Der perfekte Ort, um nach Training oder Runde mit weitem Blick über den Platz zu entspannen und einzukehren." },
        { t: "Dein Trainingsort", d: "Heimat der Golfcoaching Academy – hier finden Kurse & Einzeltraining statt.", long: "Hier ist die Heimat der Golfcoaching Academy Wendlingen. Sämtliche Gruppenkurse, Platzreife-Kurse und Einzeltrainings mit Michael Wolf und seinem PGA-Team finden direkt auf dieser Anlage statt." },
      ],
      addressTitle: "Adresse",
      address: "Golfclub Kirchheim-Wendlingen e.V.\nAm Schulerberg 1\n73230 Kirchheim unter Teck\nDeutschland",
      mapTitle: "Anfahrt",
      mapHint: "Mit einem Klick in Deiner Navigations-App öffnen",
      mapCta: "Route öffnen",
      cta: "Zur Website des Golfclubs",
      ctaUrl: "golf-kirchheim.de",
    },
    footer: {
      tagline: "Ganzheitliches Golftraining im Golfclub Kirchheim-Wendlingen e.V.",
      poweredBy: "powered by golfcoaching.online",
      nav: "Navigation",
      legal: "Rechtliches",
      rights: "Alle Rechte vorbehalten.",
      sponsors: "Partner & Sponsoren",
    },
    trackman: {
      kicker: "TrackMan Scope-Hütte",
      title: "TrackMan Scope-Hütte buchen",
      sub: "Buche Deine Stunde auf der Driving Range des Golfclub Kirchheim-Wendlingen – täglich von 20:00 bis 24:00 Uhr. Wähle einen oder mehrere aufeinanderfolgende Stunden-Slots. Verfügbar nach erfolgreicher Vorabzahlung.",
      locationFallback: "Driving Range GC Kirchheim-Wendlingen",
      memberLabel: "Mitglied GC KW",
      guestLabel: "Gast / Nichtmitglied",
      bookingTitle: "Deine Buchung",
      memberQuestion: "Mitglied GC Kirchheim-Wendlingen?",
      consentVideo: "Ich bestätige, dass ich darüber informiert wurde, dass die TrackMan Scope-Hütte und der Zugangsbereich aus Sicherheitsgründen videoüberwacht werden können.",
      consentKey: "Ich verpflichte mich, den Schlüssel nach der Nutzung unverzüglich und ordnungsgemäß in die Schlüsselbox zurückzulegen. Mir ist bekannt, dass bei Verlust oder Nicht-Rückgabe Kosten entstehen können.",
      paymentNote: "Sichere Vorabzahlung über Stripe/PayPal. Der Slot ist während der Zahlung reserviert. Der Zugangscode wird separat vor Deiner Buchung per E-Mail zugesendet.",
      doneTitle: "Buchung bestätigt",
      doneText: "Vielen Dank! Deine TrackMan-Buchung ist bezahlt und bestätigt.",
      doneNote: "Der Zugangscode folgt separat vor Deiner Buchung.",
    },
  },
  en: {
    nav: {
      home: "Home",
      news: "News",
      trainer: "Coach",
      kurse: "Courses",
      einzeltraining: "Private",
      onlinecoaching: "Online Coaching",
      golfclub: "Golf Club",
      kontakt: "Contact",
      impressum: "Imprint",
      cta: "Get started",
    },
    marquee: "POWERED BY GOLFCOACHING.ONLINE  ///  HOLISTIC GOLF TRAINING  ///  FROM BEGINNER TO PRO  ///  GC KIRCHHEIM-WENDLINGEN  ///",
    home: {
      kicker: "// GOLFCOACHING ACADEMY // WENDLINGEN",
      h1a: "GOLF,",
      h1b: "HOLISTIC.",
      sub: "The new golf school by PGA coach Michael Wolf at Golfclub Kirchheim-Wendlingen e.V. Holistic training – from your first swing to pro level.",
      newsletterLabel: "Subscribe to the newsletter",
      namePh: "Your name",
      emailPh: "Your email address",
      subscribe: "Subscribe",
      subscribed: "Thanks! You're on the list.",
      learnCourses: "Explore courses",
      stat1: "30+", stat1l: "Years coaching",
      stat2: "PGA", stat2l: "Professional",
      stat3: "360°", stat3l: "Holistic",
      newsKicker: "// NEWS // UPDATES",
      newsTitle: "Latest News",
      offersKicker: "// PROGRAMS",
      offersTitle: "Your path. Your golf.",
      offers: [
        { t: "Courses", d: "Structured group courses for beginners & advanced players incl. course permit.", to: "/kurse" },
        { t: "Private", d: "Individual 1:1 coaching with technique and video analysis.", to: "/einzeltraining" },
        { t: "Online Coaching", d: "Train from anywhere – video analysis & a personal training plan.", to: "/onlinecoaching" },
      ],
      more: "Learn more",
    },
    trainer: {
      kicker: "// YOUR COACH",
      title: "Michael Wolf",
      role: "Founder & Head Coach · PGA Golf Professional · Ex-Tour Player",
      bio: [
        "Michael Wolf is a PGA Golf Professional, former tour player and German DGL Champion. With over 30 years of experience in golf, he coaches players of all levels – from absolute beginners to ambitious competitors. He also holds a degree in Sports Economics.",
        "His approach is holistic: technique, athleticism, mental training and strategy all work together. As the founder of golfcoaching.online, he combines modern online methods with personal on-site training.",
        "At the Golfcoaching Academy Wendlingen, located at Golfclub Kirchheim-Wendlingen e.V., he brings this knowledge straight to the range – and he also coaches at GC Neckartal e.V.",
      ],
      qualsTitle: "Qualifications",
      quals: [
        "PGA Golf Professional",
        "Former tour player",
        "German Champion",
        "Founder of golfcoaching.online",
        "Degree in Sports Economics",
        "Former 1. Bundesliga coach",
      ],
      cta: "Request training",
    },
    trainer2: {
      kicker: "// COACH 02",
      title: "Christian Tobias",
      role: "PGA Golf Professional · PGA of Germany Teaching Pro · since 1989",
      bio: [
        "Christian Tobias is a PGA of Germany teaching professional and has been at home on the range with passion since 1989. A trained sports scientist, he blends technique, tactics and athleticism into one coherent game.",
        "His credo: \"Inspired by Difference.\" No two people and no two swings are alike – a rigid one-size-fits-all approach has no place in his lessons. Through precise observation of your movements, he tailors the swing exactly to your physical abilities.",
        "Over three decades he gained experience as a (head) pro at renowned clubs across Germany and Florida – from Schloß Monrepos and Sigmaringen to Fort Myers. Today he brings this knowledge to the Golfcoaching Academy Wendlingen.",
      ],
      qualsTitle: "Qualifications",
      quals: [
        "PGA of Germany Teaching Pro (since 1989)",
        "Degree in Sports Science",
        "Head pro incl. Schloß Monrepos & Sigmaringen",
        "Coaching stints in Germany & Florida (USA)",
        "Personal Trainer & tactics coach",
      ],
      cta: "Request training",
    },
    trainer3: {
      kicker: "// COACH 03",
      title: "Moritz Ehrismann",
      role: "PGA Professional · Junior & Beginner Coach",
      bio: [
        "Moritz Ehrismann has lived for golf for nine years. At his home club Bad Liebenzell he lowered his handicap to 9 just two years after taking it up – reaching a best handicap of 5 as a junior. Today he plays consistently between handicap 0 and 3.",
        "Numerous tournament wins, including at GC Bad Liebenzell, shaped his deep understanding of the game. He passes this competitive experience straight on to his students.",
        "After his C-level coaching qualification he gained valuable experience at Öschberghof and then completed his PGA Professional training at Hetzenhof. Today he works as a self-employed PGA Professional – with full passion and a special talent for explaining golf simply.",
      ],
      qualsTitle: "Qualifications",
      quals: [
        "PGA Professional",
        "Playing strength handicap 0–3",
        "Specialist: kids & juniors",
        "Explains golf simply & clearly",
        "Multiple tournament winner (Bad Liebenzell)",
        "Trained at Öschberghof & Hetzenhof",
      ],
      cta: "Request training",
    },
    trainer4: {
      kicker: "// COACH 04",
      title: "Mikael Krantz",
      monogram: "MK",
      role: "PGA Golf Professional · Former European Tour player · Grade G4",
      bio: [
        "Mikael Krantz has played golf since 1973 and enjoyed many successful years as an international playing professional. On the European Tour (1989–1994) and Challenge Tour (1991–1999) he competed against greats such as Bernhard Langer, Seve Ballesteros and Tiger Woods – five Challenge Tour wins and three British Open appearances are among his highlights.",
        "In 2004 the Swedish-born pro moved to Germany and has taught at the Kirchheim-Wendlingen golf facility ever since. He combines his international tour experience with sound, modern coaching.",
        "Whether beginner, ambitious tournament player or senior golfer – Mikael coaches individually, practically and at every level. An experienced partner who knows exactly what matters out on the course.",
      ],
      qualsTitle: "Experience",
      quals: [
        "PGA teaching pro since 2003 (G4)",
        "Golf since 1973 · Playing pro since 1988",
        "European Tour 1989–1994",
        "5 tour wins (Challenge Tour)",
        "3× British Open appearances",
        "Beginners, tournament & senior golf",
      ],
      cta: "Book training",
    },
    kurse: {
      kicker: "// COURSES & EVENTS · BOOK ONLINE",
      title: "Courses",
      intro: "Choose your course, check available dates in the calendar and book online in a few clicks.",
      emptyText: "No courses available right now. Please check back soon.",
      calendarKicker: "// YEAR CALENDAR",
      calendarTitle: "Schedule",
      regelkursKicker: "// COURSE PERMIT · THEORY",
      regelkursTitle: "Rules course & tests",
      regelkursText1: "With this online rules course we want to teach you the rules of golf in a way that is as informative as it is practical.",
      regelkursText2: "Strengthen your game: only with sound knowledge of the rules can you play tournaments with confidence and decide when and how to take penalty-free relief.",
      regelkursCta: "Start rules course",
      voucherTitle: "Gift a golf voucher",
      voucherText: "Value voucher for courses & TrackMan · valid 3 years · instant PDF",
      voucherCta: "Gift now",
    },
    regelkurs: {
      kicker: "// RULES COURSE · COURSE PERMIT",
      title: "Rules course",
      intro: "Complete your rules tests here and pass the rules part of the course permit – online, at your own pace. Work through the lessons and finish with the rules test.",
      note: "Provided via Golftimer · progress is saved in the rules system",
    },
    gutschein: {
      kicker: "Gift",
      title: "Golf Voucher",
      intro: "Gift golf experiences: the value voucher works for group courses and TrackMan, is valid for 3 years and is sent as a printable PDF.",
      redeemNote: "Redeemable for group courses and TrackMan. Not for 1:1 training. Partial redemption possible – remaining balance stays.",
    },
    einzel: {
      kicker: "// 1:1 // PRIVATE",
      title: "Private Coaching",
      intro: "Maximum progress through individual coaching. Every session is tailored exactly to you, your level and your goals.",
      features: [
        { t: "Video Analysis", d: "Detailed swing and movement analysis in slow motion." },
        { t: "Personal Plan", d: "A training plan that fits your goals precisely." },
        { t: "Holistic", d: "Technique, athleticism, mental and strategy in one concept." },
        { t: "Flexible Times", d: "Training times that adapt to your schedule." },
      ],
      cta: "Request a session",
    },
    online: {
      kicker: "// POWERED BY GOLFCOACHING.ONLINE",
      badge: "www.golfcoaching.online",
      h1a: "YOUR GOLF",
      h1b: "ONLINE PLATFORM",
      intro: "golfcoaching.online is a streaming platform – but much more too. Hundreds of masterclass videos from world-renowned coaches. Built-in AI Swing Coach, online shop, blog, chatroom, discounts and much more. The perfect complement to your on-course training.",
      netflix: "Your golf Netflix – better than YouTube.",
      launch: "Official Launch · February 1st",
      ctaText: "Go to the platform",
      ctaUrl: "www.golfcoaching.online",
      watch: "Start streaming",
      oneStop: 'The "One Stop Shop" for online golf learning.',
      aiKicker: "// AI SWING COACH",
      aiTitle: "Your personal AI Swing Coach",
      aiText: "Upload your swing video and receive a professional analysis in seconds – technique, flaws and concrete drills. Available 24/7, right on your smartphone.",
      aiBullets: ["Upload your swing video", "Instant AI analysis", "Concrete feedback & drills", "Track your progress"],
      featKicker: "// THE PLATFORM",
      featTitle: "All in one membership",
      features: [
        { t: "Video Streaming", d: "Netflix-like masterclass library for every level and every topic." },
        { t: "AI Swing Coach", d: "Upload your swing and instantly receive a professional analysis & feedback." },
        { t: "Online Shop", d: "Exclusive products, equipment and member discounts." },
        { t: "And much more", d: "E-books, training plans, community and constantly new content." },
      ],
      teamKicker: "// THE COACHES",
      teamTitle: "Learn from the best",
      teamIntro: "Tour pros, PGA professionals and experts from around the world – exclusively on golfcoaching.online.",
      showcaseTitle: "Stream on every device",
      mcKicker: "// MASTERCLASSES",
      mcTitle: "Holistic Masterclasses",
      mcIntro: "From tour strategy to putting – on golfcoaching.online you'll find structured masterclasses for every part of your game. Created by Michael Wolf and world-renowned experts.",
      topics: ["Tour", "Tactics", "Technique", "Beginner Tips", "Nutrition", "Statistics", "Short Game", "Putting", "Long Game", "Mental", "Fitness", "Yoga", "Breathwork", "Golf IQ", "Flaws & Fixes", "On-Course Coaching"],
      plansKicker: "// MEMBERSHIP",
      plansTitle: "Membership Plans",
      plansIncludeTitle: "All membership plans include:",
      includes: [
        "Access to all videos",
        "Access to AI golf coach",
        "Member benefits & discounts (coming soon)",
        "Community blog (coming soon)",
        "Members chatroom (coming soon)",
      ],
      trial: "Start Free Trial",
      popular: "Popular",
      plans: [
        { name: "6 Month Bronze", price: "49", per: "Every month", valid: "Valid for 6 months · + 14 day free trial", features: ["Access to all videos", "AI golf coach", "Member benefits & discounts", "Community blog", "Members chatroom"] },
        { name: "12 Months Silver", price: "29", per: "Every month", valid: "Valid for 12 months · + 3 day free trial", features: ["Access to all videos", "AI golf coach", "Member benefits & discounts", "Community blog", "Members chatroom"] },
        { name: "24 Months Gold", price: "24", per: "Every month", valid: "Valid for 24 months · + 3 day free trial", popular: true, features: ["Access to all videos", "AI golf coach", "Member benefits & discounts", "Community blog", "Members chatroom"] },
        { name: "5 Year Platinum VIP", price: "1,200", per: "Every 5 years", valid: "3 day free trial", features: ["15% discount on gold plan", "Early access to live events & retreats", "VIP platinum membership gift", "Access to everything"] },
      ],
    },
    kontakt: {
      kicker: "// CONTACT",
      title: "Contact",
      intro: "Ready to get started? Send us a message – we'll get back to you as soon as possible.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sent: "Thanks! Your message has been sent.",
      addressTitle: "Location",
      address: "Golfcoaching Academy Wendlingen\nGolfclub Kirchheim-Wendlingen e.V.\nGermany",
      emailLabel: "Email",
      emailValue: "training@wolfmichael.de",
    },
    impressum: {
      kicker: "// LEGAL",
      title: "Imprint",
      content: `Information pursuant to § 5 German Digital Services Act (DDG)

Golfcoaching Academy Wendlingen
Owner
Michael Wolf – Golf Professional
Ringstraße 8
70736 Fellbach
Germany

Contact
Phone: +49 (0)151 41929686
Email: training@wolfmichael.de
Website: www.golfcoaching-academy.online

VAT identification number
VAT identification number pursuant to § 27a of the German VAT Act:
DE815679035

Responsible for content pursuant to § 18 (2) MStV
Michael Wolf
Ringstraße 8
70736 Fellbach
Germany

Professional title
Golf Professional
Professional title awarded in Germany.

Training location
The Golfcoaching Academy Wendlingen offers golf lessons, courses, course-permit programs and events at the golf facility of Golfclub Kirchheim-Wendlingen e.V.
Golfclub Kirchheim-Wendlingen e.V. is not the operator of this website and assumes no responsibility for its content.
The sole contractual partner for all services offered on this website is:
Michael Wolf – Golf Professional

Liability for content
The contents of this website were created with the greatest care. However, we assume no liability for the accuracy, completeness and timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with statutory provisions.

Liability for links
This website contains links to external third-party websites. We have no influence on their content. The respective operator is solely responsible for the content of the linked pages.

Copyright
All content, images, videos, graphics, logos, designs and texts published on this website are subject to German copyright law. Any reproduction, editing or use beyond the limits of copyright law requires the prior written consent of the respective rights holder.

Last updated: July 2026`,
    },
    golfclub: {
      kicker: "// THE CLUB",
      title: "Golf Club",
      intro: "The Golfcoaching Academy Wendlingen is based at Golfclub Kirchheim-Wendlingen e.V. – one of the most beautiful golf facilities in the Stuttgart region. Here you train on well-kept fairways, a modern driving range and in a welcoming clubhouse.",
      rangeTitle: "Our TrackMan Range",
      rangeIntro: "Train smarter, play better. At 300 metres long, our TrackMan Range offers the perfect space for long drives and precise practice – every shot made visible, measurable and easy to understand.",
      rangePoints: [
        "10 covered, heated bays with screens – open daily until 10 pm, weatherproof",
        "Free TrackMan app (iOS & Android) – also playable from the grass tee",
        "Precise data on distance, ball flight & more – save and analyse your progress",
        "Virtual rounds on top international courses plus games & challenges",
        "Perfect for solo training or together with the pro",
        "For every level – from beginner to ambitious golfer",
      ],
      features: [
        { t: "Driving Range", d: "Modern range & practice greens for effective, focused training.", long: "A 300 m driving range playable from both ends, with 10 covered, heated bays and modern TrackMan & SCOPE technology. Plus two large putting greens and chip & pitch areas with a practice bunker – ideal for focused, effective training at every level." },
        { t: "Surrounded by nature", d: "Well-kept fairways in a scenic setting between Kirchheim & Wendlingen.", long: "Nestled between Kirchheim and Wendlingen, the facility sits in a scenic landscape at the foot of the Swabian Alb. Well-kept fairways, mature trees and wide views make every round a true nature experience." },
        { t: "Clubhouse & dining", d: "A welcoming clubhouse with dining to round off your round.", long: "The welcoming clubhouse offers a restaurant with a sunny terrace and a pro shop. The perfect place to relax and dine with a wide view across the course after training or a round." },
        { t: "Your training base", d: "Home of the Golfcoaching Academy – where courses & private lessons take place.", long: "This is the home of the Golfcoaching Academy Wendlingen. All group courses, licence courses and private lessons with Michael Wolf and his PGA team take place right here at this facility." },
      ],
      addressTitle: "Address",
      address: "Golfclub Kirchheim-Wendlingen e.V.\nAm Schulerberg 1\n73230 Kirchheim unter Teck\nGermany",
      mapTitle: "Directions",
      mapHint: "Open in your navigation app with one click",
      mapCta: "Open route",
      cta: "Visit the golf club website",
      ctaUrl: "golf-kirchheim.de",
    },
    footer: {
      tagline: "Holistic golf training at Golfclub Kirchheim-Wendlingen e.V.",
      poweredBy: "powered by golfcoaching.online",
      nav: "Navigation",
      legal: "Legal",
      rights: "All rights reserved.",
      sponsors: "Partners & Sponsors",
    },
    trackman: {
      kicker: "TrackMan Scope hut",
      title: "Book the TrackMan Scope hut",
      sub: "Book your hour at the Golfclub Kirchheim-Wendlingen driving range – daily from 8pm to midnight. Pick one or more consecutive hourly slots. Available after successful prepayment.",
      locationFallback: "Driving Range GC Kirchheim-Wendlingen",
      memberLabel: "Member GC KW",
      guestLabel: "Guest / non-member",
      bookingTitle: "Your booking",
      memberQuestion: "Member of GC Kirchheim-Wendlingen?",
      consentVideo: "I confirm I have been informed that the TrackMan Scope hut and access area may be video-monitored for security reasons.",
      consentKey: "I commit to returning the key to the key box promptly and properly after use. I am aware that costs may arise in case of loss or non-return.",
      paymentNote: "Secure prepayment via Stripe/PayPal. The slot is reserved during payment. Your access code is sent separately by email before your booking.",
      doneTitle: "Booking confirmed",
      doneText: "Thank you! Your TrackMan booking is paid and confirmed.",
      doneNote: "The access code follows separately before your booking.",
    },
  },
};
